import { render, staticRenderFns } from "./listaProdutosEmpenhoStart.vue?vue&type=template&id=71af2f8e"
import script from "./listaProdutosEmpenhoStart.vue?vue&type=script&lang=js"
export * from "./listaProdutosEmpenhoStart.vue?vue&type=script&lang=js"
import style0 from "./listaProdutosEmpenhoStart.vue?vue&type=style&index=0&id=71af2f8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports